"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activeKeys$ = exports.keyUp$ = exports.keyDown$ = void 0;
var rxjs_1 = require("rxjs");
// TODO: label input actions to allow easy re-mapping
// other components should listen for named triggers, inputs will manage the actions
var inputActions = {
    moveLeft: ["a"],
    moveRight: ["d"],
    moveUp: ["w"],
    moveDown: ["s"],
    castSpell: [" "],
    pause: ["escape"],
    debugMode: ["`"],
};
// player input and observables
var inputs = ['w', 'a', 's', 'd', ' ', 'enter', 'escape', '`', 'q', 'e', 'f', '1', '2'];
exports.keyDown$ = (0, rxjs_1.fromEvent)(document, 'keydown').pipe((0, rxjs_1.filter)(function (e) { return inputs.includes(e.key.toLowerCase()); }), (0, rxjs_1.map)(function (e) { return ({
    key: e.key.toLowerCase(),
    isDown: true,
}); }));
exports.keyUp$ = (0, rxjs_1.fromEvent)(document, 'keyup').pipe((0, rxjs_1.filter)(function (e) { return inputs.includes(e.key.toLowerCase()); }), (0, rxjs_1.map)(function (e) { return ({
    key: e.key.toLowerCase(),
    isDown: false,
}); }));
// tracking whether or not key is currently pressed
exports.activeKeys$ = (0, rxjs_1.merge)(exports.keyDown$, exports.keyUp$).pipe((0, rxjs_1.distinctUntilChanged)(function (prev, curr) { return prev.key === curr.key && prev.isDown === curr.isDown; }), (0, rxjs_1.scan)(function (acc, curr) {
    acc[curr.key] = curr.isDown;
    return acc;
}, {}));
